export function VendorInvoicePaymentsCtrl ($state, $scope, $translate, workshopAPI) {
  $scope.showVendorInvoicePayments = !!$scope.payments.length;

  $scope.tableSettings = {
    columns: [
      {
        field : 'vendor_payment_number',
        header: {
          text: $translate.instant('INVOICE_SPACE.PAYMENT_NO')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('INVOICE_SPACE.PAYMENT_DATE')
        },
        pipe  : 'globalDate'
      },
      {
        field : 'status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe  : 'invoiceStatus'
      },
      {
        classes: 'text-right',
        field  : 'amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.PAYMENT_AMOUNT')
        },
        pipe   : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendor_invoices/payment_count_for_vendor_invoice', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.getPayments = ( params ) => {
    return workshopAPI.get('/vendor_invoices/payments_for_vendor_invoice_list', [
      $scope.invoice.id,
      params.offset || 0,
      params.pageSize,
      params.field,
      params.direction
    ]).then(payments => {
      $scope.payments = payments;

      return payments;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.vendor-payment', {
      vendor_id: event.row.vendor_id,
      id       : event.row.id
    });
  };
}